import { Injectable } from '@angular/core';
import { IUser, User } from '../models/IUser';

@Injectable()
export class UserService {

  constructor() { }

  // TODO change session storage to local storage
  set user(user: IUser) {
    localStorage.setItem('user', JSON.stringify(user));
  }

  get user(): IUser {
    const u = JSON.parse(localStorage.getItem('user'));
    if (u) {
      return new User(u);
    }
  }

  set localUserId(id: number) {
    localStorage.setItem('localUserId', JSON.stringify(id));
  }

  get localUserId(): number {
    return parseInt(localStorage.getItem('localUserId'), 10);
  }

  getUserAssociationIds(): number[] {
    return this.user.userAssociations ? this.user.userAssociations.map(association => association.institutionId) : [];
  }
}
